<div class="main">
  <div class="header-wrapper">
    <app-header></app-header>
  </div>

  <div class="row m-0 py-lg-5 py-3 px-lg-5 px-0  wrapper">
    <div class="col-lg-2 p-0">
      <app-business-sidenav></app-business-sidenav>
    </div>
    <div class="col-lg-10 p-0 main-content-container">
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="footer-wrapper">
    <!-- <div class="col-lg-2 p-0">
      <app-business-sidenav></app-business-sidenav>
    </div> -->
    <app-footer></app-footer>
  </div>
</div>












  
  
  
  
  
  
  
  
  
  
  
    
